// extracted by mini-css-extract-plugin
export default {"youTubeContainer":"_13Bqu","pipButtonHidden":"_3KFVP"};